import { render, staticRenderFns } from "./NavigationClientList.vue?vue&type=template&id=198a7964&"
import script from "./NavigationClientList.vue?vue&type=script&lang=js&"
export * from "./NavigationClientList.vue?vue&type=script&lang=js&"
import style0 from "./NavigationClientList.vue?vue&type=style&index=0&id=198a7964&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports